import React from 'react';
import classNames from 'classnames';
import './ConfiguratorDropdown.css';

const hasMeta = (meta, idx, property) => meta && meta[idx] && meta[idx][property];

const ConfiguratorDropdown = ({
  id, onSelect, keys, options, meta, getString
}) => (

  options.map((option, idx) => {
    const key = keys ? keys[idx] : option;
    const disabled = hasMeta(meta, idx, 'disabled');
    const bottomUnderline = hasMeta(meta, idx, 'underline');
    const topUnderline = bottomUnderline & idx > 0;
    const optionalPrefix = hasMeta(meta, idx, 'optional') ? getString('optional', 'accessories') : '';
    return (
      <button
        key={key}
        type="button"
        className={classNames({ disabled, 'bottom-underline': bottomUnderline, 'top-underline': topUnderline })}
        onClick={() => (!disabled ? onSelect(id, key) : 0)}
        dangerouslySetInnerHTML={{ __html: `${optionalPrefix}${getString(option)}` }}
      />
    );
  })
);

export default ConfiguratorDropdown;
